import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List, Set } from 'immutable';
import { Router } from '@angular/router';
import { EventListStore } from '../../service/event-list.store';
import { OnyxSummaryEvent } from '../../models/event.summary';
import { MenuStore } from '../../../menus/service/menu.store';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { EventSearchParametersStore } from '../../service/event-search-parameters.store';

@Component({
  selector: 'pioneer-event-list-default-table',
  templateUrl: './event-list-default-table.component.html'
})
export class EventListDefaultTableComponent implements OnInit {

  private data: Observable<List<OnyxSummaryEvent>>;

  constructor(private eventListStore: EventListStore,
              private environment: EnvironmentConfiguration,
              private router: Router) {
  }

  ngOnInit() {
    this.data = this.eventListStore.events;
  }

  get events(): Observable<List<OnyxSummaryEvent>> {
    return this.data;
  }

  get eventCount(): Observable<number> {
    return this.eventListStore.totalEventCount;
  }

  get eventCountForTranslate(): Observable<Object> {
    return this.eventCount.map(count => {
      return {
        eventCount: count
      };
    });
  }

  get eventsAboveMax(): Observable<boolean> {
    return this.eventCount.map(eventCount => {
      return eventCount > this.maxEvents;
    });
  }

  get eventsPresent(): Observable<boolean> {
    return this.eventCount.map(eventCount => {
      return eventCount > 0;
    });
  }

  get maxEvents(): number {
    return this.environment.events.maxEvents;
  }

  get maxEventsForTranslate(): Object {
    return {
      maxEvents: this.maxEvents
    };
  }

  onSelect(event: OnyxSummaryEvent): void {
    this.router.navigate([ '/event', event.eventId ]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-list/event-list-default-table/event-list-default-table.component.ts